"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identifier = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
function Identifier() {
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_IDENTIFIER_PANEL_TITLE", defaultMessage: "Identifik\u00E1tor" }) },
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "essId.source", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_IDENTIFIER_FIELD_LABEL_SOURCE", defaultMessage: "Zdroj" }) }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "essId.id", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_IDENTIFIER_FIELD_LABEL_ID", defaultMessage: "Id" }) })));
}
exports.Identifier = Identifier;
//# sourceMappingURL=identifier.js.map